import { render, staticRenderFns } from "./m-category-carousel.vue?vue&type=template&id=7677677b&"
import script from "./m-category-carousel.vue?vue&type=script&lang=js&"
export * from "./m-category-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports